import React, { Suspense, lazy, useState } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "./Navigation";
import CookieBanner from "../components/CookieBanner";

const Footer = lazy(() => import("./Footer"));
const LoginModal = lazy(() => import("../pages/Auth/LoginModal"));
const RegistrationFlow = lazy(() => import("../pages/Auth/RegistrationFlow"));

const Layout = ({ children }) => {
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const hideFooter = location.pathname === "/membership/register";

  const openLogin = () => {
    setShowRegister(false);
    setShowLogin(true);
  };

  const openRegister = (planData = null) => {
    setShowLogin(false);
    setSelectedPlan(planData);
    setShowRegister(true);
  };

  const closeAll = () => {
    setShowLogin(false);
    setShowRegister(false);
    setSelectedPlan(null);
  };

  return (
    <div className="app-layout">
      <Navigation onLoginClick={openLogin} />

      <main className="main-content">
        {React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, {
                onOpenRegister: openRegister,
                onOpenLogin: openLogin,
              })
            : child,
        )}
      </main>

      {!hideFooter && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}

      <CookieBanner />

      {showLogin && (
        <Suspense fallback={null}>
          <LoginModal
            onClose={closeAll}
            onSwitchToRegister={() => openRegister(null)}
          />
        </Suspense>
      )}

      {showRegister && (
        <Suspense fallback={null}>
          <RegistrationFlow
            planData={selectedPlan}
            onClose={closeAll}
            onSwitchToLogin={openLogin}
          />
        </Suspense>
      )}
    </div>
  );
};

export default Layout;
